import {
  Entity,
  PrimaryKey,
  Property,
  ManyToOne,
  Unique,
} from '@mikro-orm/core';
import { User } from './user.entity';
import { Category } from './category.entity';
import { Rel } from '@mikro-orm/core';

@Entity({ tableName: 'user_categories' })
@Unique({ properties: ['user', 'category'] })
export class UserCategory {
  @PrimaryKey()
  id!: number;

  @ManyToOne(() => User)
  user!: Rel<User>;

  @ManyToOne(() => Category)
  category!: Rel<Category>;

  @Property({ type: 'datetime' })
  created_at: Date = new Date();

  @Property({ type: 'datetime', onUpdate: () => new Date() })
  updated_at?: Date = new Date();

  @Property({ type: 'datetime', nullable: true })
  deleted_at?: Date | null = null;
}
